var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('h4',[_vm._v("About IWI Certifications")]),_c('ul',[_vm._l((Object.values(_vm.data.certifications)),function(cert){return [(cert.slug != _vm.pageSlug)?_c('li',{key:cert.id},[_c('router-link',{attrs:{"to":'/' + cert.uri}},[_vm._v(_vm._s(cert.acronym))])],1):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }